import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { ToasterService } from '../service/common/toaster.service';
import { HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { tap } from 'rxjs/operators';

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
  // return next(req).pipe(
  //   tap(event => {
  //     if (event instanceof HttpResponse) {
  //       // Extract token from header (adjust header key as needed)
  //       const token = event.headers.get('Authorization'); // or 'X-Auth-Token'
  //       if (token) {
  //         // Optionally strip "Bearer " prefix
  //         const extractedToken = token.startsWith('Bearer ') ? token.substring(7) : token;
  //         // Save to localStorage
  //         localStorage.setItem('jwtToken', extractedToken);
  //       }
  //     }
  //   })
  // );
  // return next(req);
  const toaster = inject(ToasterService);
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      let message = 'An unexpected error occurred';
      if (error.error?.message) {
        message = error.error.message;
      } else if (error.message) {
        message = error.message;
      }
      toaster.error('Error', message);
      return throwError(() => error);
    })
  );
};
